// Alert kinds: the label people read and the tone of the inbox dot.
export type AlertTone = "new" | "warn" | "info" | "muted";

export const ALERT_KINDS: Record<string, [string, AlertTone]> = {
  feed_new: ["New matches", "new"],
  search_new: ["New matches", "new"],
  deadline: ["Due date changed", "warn"],
  amended: ["Amended", "info"],
  attachments: ["New attachments", "info"],
  closed: ["Closed", "muted"],
  reopened: ["Reopened", "info"],
  due_soon: ["Due soon", "warn"],
  forecast_moved: ["Expected date moved", "warn"],
  released: ["Released as a solicitation", "new"],
  awarded: ["Awarded", "new"],
  budget_changed: ["Budget changed", "warn"],
  budget_renamed: ["Budget line renamed", "info"],
  budget_dropped: ["Dropped from the budget", "warn"],
  budget_mark: ["Congress acted", "info"],
  budget_record: ["New record for a budget line", "new"],
};

export const FREQUENCIES: [string, string, string][] = [
  ["off", "Off", "Only in GovChew"],
  ["daily", "Daily digest", "One email each morning"],
  ["instant", "As they arrive", "An email after each check"],
];

export const human = (s: string): string => {
  const t = (s || "").replace(/_/g, " ").trim();
  return t ? t[0]!.toUpperCase() + t.slice(1) : "";
};

/** Today, Yesterday, or "Tuesday, Sep 22". */
export function dayLabel(iso: string): string {
  const d = new Date(iso);
  const t = new Date(new Date().toDateString());
  const diff = Math.round((t.getTime() - new Date(d.toDateString()).getTime()) / 864e5);
  return diff === 0 ? "Today" : diff === 1 ? "Yesterday" : d.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" });
}

export const timeOf = (iso: string): string => new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
